import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useMaster from "../hooks/useMaster";

const Navdata = () => {
  const history = useNavigate();

  const { getMenuAccess } = useMaster();

      const {isLoading,data} = getMenuAccess()
  
  // //state data
  // const [isDashboard, setIsDashboard] = useState(false);
  // const [isApps, setIsApps] = useState(false);
  // const [isAuth, setIsAuth] = useState(false);
  // const [isPages, setIsPages] = useState(false);
  // const [isBaseUi, setIsBaseUi] = useState(false);
  // const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  // const [isForms, setIsForms] = useState(false);
  // const [isTables, setIsTables] = useState(false);
  // const [isCharts, setIsCharts] = useState(false);
  // const [isIcons, setIsIcons] = useState(false);
  // const [isMaps, setIsMaps] = useState(false);
  // const [isMultiLevel, setIsMultiLevel] = useState(false);

  // const [iscurrentState, setIscurrentState] = useState("Dashboard");


  // useEffect(() => {
  //   document.body.classList.remove("twocolumn-panel");
  //   // if (iscurrentState !== "Dashboard") {
  //   //   setIsDashboard(false);
  //   // }
  //   // if (iscurrentState !== "Apps") {
  //   //   setIsApps(false);
  //   // }
  //   // if (iscurrentState !== "Auth") {
  //   //   setIsAuth(false);
  //   // }
  //   // if (iscurrentState !== "Pages") {
  //   //   setIsPages(false);
  //   // }
  //   // if (iscurrentState !== "BaseUi") {
  //   //   setIsBaseUi(false);
  //   // }
  //   // if (iscurrentState !== "AdvanceUi") {
  //   //   setIsAdvanceUi(false);
  //   // }
  //   // if (iscurrentState !== "Forms") {
  //   //   setIsForms(false);
  //   // }
  //   // if (iscurrentState !== "Tables") {
  //   //   setIsTables(false);
  //   // }
  //   // if (iscurrentState !== "Charts") {
  //   //   setIsCharts(false);
  //   // }
  //   // if (iscurrentState !== "Icons") {
  //   //   setIsIcons(false);
  //   // }
  //   // if (iscurrentState !== "Maps") {
  //   //   setIsMaps(false);
  //   // }
  //   // if (iscurrentState !== "MuliLevel") {
  //   //   setIsMultiLevel(false);
  //   // }
  //   // if (iscurrentState === "Widgets") {
  //   //   history("/widgets");
  //   //   document.body.classList.add("twocolumn-panel");
  //   // }

  // }, [
  //   history,
  //   iscurrentState,
  //   isDashboard,
  //   isApps,
  //   isAuth,
  //   isPages,
  //   isBaseUi,
  //   isAdvanceUi,
  //   isForms,
  //   isTables,
  //   isCharts,
  //   isIcons,
  //   isMaps,
  //   isMultiLevel,
  // ]);

  return <React.Fragment>
    {!isLoading && data?.data}
  </React.Fragment>;
};
export default Navdata;
